var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunctionalSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76027 38.1265H1.53118C1.13736 38.1265 0.824097 37.8087 0.824097 37.4194V25.9941C0.824097 25.6003 1.14184 25.287 1.53118 25.287H5.76027C6.15409 25.287 6.46735 25.6048 6.46735 25.9941V37.4194C6.47183 37.8087 6.15409 38.1265 5.76027 38.1265Z",
    stroke: "url(#paint0_linear_3_3)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47186 26.6967C6.47186 26.6967 10.504 25.1125 15.024 26.6967C19.5485 28.281 24.4086 28.451 23.3882 31.7045C23.0436 32.8099 21.7189 33.253 19.092 32.1789C17.1542 31.3868 14.3169 32.3221 14.3169 32.3221",
    stroke: "url(#paint1_linear_3_3)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47186 36.7302L16.0981 38.7082C16.0981 38.7082 19.092 39.6615 21.9203 38.122C24.7487 36.5825 34.2451 30.2277 34.2451 30.2277C34.2451 30.2277 35.9144 28.9567 34.7821 27.2024C34.7821 27.2024 33.7349 25.3944 31.56 26.7236C29.385 28.0527 23.3927 31.7045 23.3927 31.7045",
    stroke: "url(#paint2_linear_3_3)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2912 12.3523C28.3425 12.3566 28.3894 12.3651 28.4364 12.3779C28.4364 12.3694 28.4364 12.3608 28.4407 12.3523H28.2912ZM9.12811 12.3523V12.3566C9.12811 12.3651 9.13238 12.3694 9.13238 12.3779C9.17935 12.3651 9.22632 12.3566 9.27329 12.3523H9.12811Z",
    stroke: "url(#paint3_linear_3_3)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4236 9.13501C28.257 9.17347 28.082 9.19483 27.9026 9.19483C26.6601 9.19483 25.6567 8.1865 25.6567 6.94745C25.6567 6.1442 26.0709 5.44349 26.7028 5.04614C26.0922 4.20444 25.3578 3.46956 24.5167 2.85858C24.491 2.84149 24.4697 2.82012 24.4441 2.80731C24.0512 3.46101 23.3339 3.89682 22.5184 3.89682C21.2758 3.89682 20.2681 2.88849 20.2681 1.64516C20.2681 1.46571 20.2895 1.29054 20.3322 1.12391C19.8284 1.03845 19.3074 1 18.7822 1C18.2485 1 17.719 1.04273 17.2109 1.12818C17.2494 1.29481 17.2664 1.46571 17.2664 1.64516C17.2664 2.88849 16.263 3.89682 15.0205 3.89682C14.2092 3.89682 13.4962 3.46529 13.1033 2.82012C13.0863 2.82867 13.0777 2.83721 13.0606 2.84576C12.2195 3.45674 11.4722 4.20017 10.8659 5.04187C11.4936 5.43922 11.912 6.1442 11.912 6.94745C11.912 8.1865 10.9086 9.19483 9.6661 9.19483C9.48249 9.19483 9.30743 9.17347 9.14091 9.13501C9.04697 9.66909 9 10.2203 9 10.7885C9 11.3226 9.04697 11.8438 9.1281 12.3565H9.27327C9.40137 12.3309 9.53373 12.3181 9.6661 12.3181C9.80273 12.3181 9.9351 12.3309 10.0632 12.3565C11.1178 12.5403 11.912 13.4589 11.912 14.5655C11.912 15.3773 11.4808 16.0951 10.8318 16.4881C10.8446 16.5052 10.8531 16.5181 10.8659 16.5351C11.4851 17.3854 12.2365 18.1331 13.0863 18.7441C13.4791 18.0861 14.2007 17.646 15.0205 17.646C16.263 17.646 17.2664 18.6543 17.2664 19.8934C17.2664 20.0857 17.2451 20.2694 17.1981 20.4446C17.2237 20.4531 17.2494 20.4531 17.2707 20.4574C17.7617 20.5343 18.2699 20.5727 18.7822 20.5727C19.3117 20.5727 19.8326 20.5343 20.3365 20.4531C20.2938 20.2737 20.2681 20.0857 20.2681 19.8934C20.2681 18.6543 21.2758 17.646 22.5184 17.646C23.3467 17.646 24.0683 18.0946 24.4569 18.7569C24.4825 18.7441 24.5038 18.727 24.5295 18.7099C25.3749 18.0904 26.1221 17.3384 26.7284 16.4881C26.088 16.0908 25.6567 15.3773 25.6567 14.5655C25.6567 13.4589 26.4509 12.5403 27.5056 12.3565C27.6336 12.3309 27.766 12.3181 27.9026 12.3181C28.035 12.3181 28.1631 12.3309 28.2912 12.3565H28.4406C28.4406 12.3437 28.4406 12.3309 28.4449 12.3224C28.5218 11.8225 28.5645 11.3098 28.5645 10.7885C28.5645 10.2245 28.5175 9.66909 28.4236 9.13501ZM22.7489 11.4208C22.719 11.596 22.6849 11.7627 22.6336 11.925C22.5098 12.3523 22.3134 12.7496 22.0658 13.1043C21.8138 13.4674 21.4979 13.7836 21.1392 14.0442C20.6524 14.3988 20.0845 14.6467 19.4611 14.7535C19.2434 14.7919 19.0128 14.8133 18.778 14.8133C18.5687 14.8133 18.3595 14.7962 18.1588 14.7663C17.5269 14.668 16.9505 14.4245 16.4552 14.0699C16.0965 13.8178 15.7848 13.5059 15.5286 13.1512C15.2639 12.7838 15.0547 12.3694 14.9266 11.925C14.8796 11.7627 14.8412 11.6046 14.8155 11.4379C14.7814 11.2286 14.7643 11.0107 14.7643 10.7928C14.7643 10.5535 14.7814 10.3271 14.8241 10.1006C14.9308 9.49391 15.1699 8.9342 15.5158 8.4514C15.7677 8.10105 16.0794 7.78487 16.4338 7.52852C16.9291 7.17389 17.5056 6.92608 18.1289 6.82354C18.3424 6.78509 18.5602 6.77227 18.7822 6.77227C19 6.77227 19.2178 6.78936 19.427 6.82354C20.0589 6.92608 20.6396 7.17389 21.1392 7.53279C21.4893 7.78915 21.801 8.10105 22.0529 8.45567C22.3945 8.9342 22.6336 9.48964 22.7404 10.0921C22.7788 10.3228 22.8002 10.5535 22.8002 10.7928C22.8002 11.0021 22.7831 11.2115 22.7489 11.4208Z",
    stroke: "url(#paint4_linear_3_3)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_3",
    x1: -5,
    y1: 28,
    x2: 43.5,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_3",
    x1: -6.5,
    y1: 28,
    x2: 15.7484,
    y2: 4.0462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_3",
    x1: -5.5,
    y1: 27.5,
    x2: 42,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_3",
    x1: 7.98785,
    y1: 12.3722,
    x2: 8.59321,
    y2: 15.9507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_3",
    x1: -9.5,
    y1: 16,
    x2: 46,
    y2: 15.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalSettings);
export default __webpack_public_path__ + "static/media/FunctionalSettings.ad58fac625a882a64073d0c3b9cb679a.svg";
export { ForwardRef as ReactComponent };